import * as Zod from 'zod';

export const deviceCategoriesScheme = Zod.object({
  id: Zod.string(),
  label: Zod.string(),
});
